import { FC } from 'react';
import { SpinnerStyled } from './styled';
import { SpinnerProps } from './types';

export const Spinner: FC<SpinnerProps> = ({ size, ...props }) => {
  return <SpinnerStyled size={size} {...props} />;
};
